// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__33xSF","fileBtn":"File_fileBtn__1sLlX","closeBtn":"File_closeBtn__3o8Gi","fileSelected":"File_fileSelected__ds_z3","disabled":"File_disabled__37aWP"};